/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractPropertiesLogDTO } from './contract-properties-log-dto';
import { EmailNotificationDetailDTO } from './email-notification-detail-dto';
import { ContractStatusEnumDTO } from './contract-status-enum-dto';


/**
 * Defines a contract entity. Contracts are assigned to tenants via the `customerIdentifier` property.
 */
export interface ContractAllOfDTO { 
    /**
     * System generated UID for the contract.
     */
    id: string;
    /**
     * Customer name used for the contract.
     */
    customerName: string;
    /**
     * Unique customer identifier. Used to link an contract to tenants.
     */
    customerIdentifier: string;
    contractPropertiesLog: Array<ContractPropertiesLogDTO>;
    notifications?: Array<EmailNotificationDetailDTO>;
    status?: ContractStatusEnumDTO;
}

export class ClsContractAllOfDTO { 
    /**
     * System generated UID for the contract.
     */
    id: string = undefined;
    /**
     * Customer name used for the contract.
     */
    customerName: string = undefined;
    /**
     * Unique customer identifier. Used to link an contract to tenants.
     */
    customerIdentifier: string = undefined;
    contractPropertiesLog: Array<ContractPropertiesLogDTO> = undefined;
    notifications?: Array<EmailNotificationDetailDTO> = undefined;
    status?: ContractStatusEnumDTO = undefined;
}



